export default {
  // fix
  data () {
    return {
      dataMixinSmsFields: [
        {
          label: '',
          key: 'isBlocked',
          tdClass: 'call-tabel-icon',
          thClass: 'call-tabel-icon',
          thStyle: { 'min-width': '36px' }
        },
        {
          label: 'ID',
          key: 'id',
          sortable: false,
          tdClass: 'call-td call-td--grey',
          thClass: 'call-th',
          thStyle: { 'min-width': '36px' }
        },
        {
          label: 'Template Name',
          key: 'name',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th',
          thStyle: { 'min-width': '136px' }
        },
        {
          label: 'Teams Available For',
          key: 'teams',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th',
          thStyle: { 'min-width': '170px' }
        },
        {
          label: 'Projects Available For',
          key: 'team_projects',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th',
          thStyle: { 'min-width': '170px' }
        },
        {
          label: 'Template Text',
          key: 'body',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th',
          thStyle: { 'min-width': '136px' }
        },
        {
          label: 'Created By',
          key: 'created_by_name',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th',
          thStyle: { 'min-width': '120px' }
        },
        {
          label: 'Created At',
          key: 'created_at',
          sortable: true,
          tdClass: 'call-td',
          thClass: 'call-th',
          thStyle: { 'min-width': '130px' }
        },
        {
          label: 'Updated At',
          key: 'updated_at',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th',
          thStyle: { 'min-width': '130px' }
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action',
          thClass: 'call-tabel-action',
          thStyle: { 'min-width': '80px' }
        }
      ]
    };
  },
  methods: {
    onHover (item) {
      item.actions = true;
    },
    onUnHover (item) {
      item.actions = false;
    }
  }
};
